import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { ActivatedRouteSnapshot } from '@angular/router';
import { CompanyService } from './company.service';
import { HttpParams, HttpResponse } from '@angular/common/http';
import { CompanyListItem } from '../models/company-list.model';
import { CompanyDetail } from '../models/company-detail.model';


@Injectable({ providedIn: 'root' })
export class ComapnyDetailResolver implements Resolve<CompanyDetail> {
  constructor(
    private companyService: CompanyService
  ) { }

  resolve(route: ActivatedRouteSnapshot) {
    const id = route.params.id;

    return this.companyService.getCompany(id);
  }
}
